import React, { useState, useEffect } from 'react';
import reviewIcon from '../images/review.png'; // Renamed this to avoid confusion

const reviews = [
  {
    name: "Rishabh Singh",
    reviewCount: 2,
    timeAgo: "a week ago",
    text: "Very well hospitality . Specially rakhi sharma she is very well and coperative . Great room neat and clean very polite staff clean washrooms. Most important i lost my gold there . Rakhi sharma called me and take care of my belongings m really thankfull of her.",
    ownerReply: "Thanks a lot 🙏",
    ownerTimeAgo: "a week ago",
    avatar: reviewIcon,
  },
  {
    name: "SUMIT KARN (SUMIT KARN)",
    reviewCount: 4,
    timeAgo: "7 months ago",
    text: "During my recent stay, I was pleased with the hotel’s service. Upon arrival, the staff informed me of a designated area where I could park my super bike, and I parked accordingly. However, after checking in, I was instructed to move my bike to a different location.",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "7 months ago",
    avatar: reviewIcon,
  },
  {
    name: " sudhir dixit ",
    reviewCount: 1,
    timeAgo: "a month ago",
    text: "Hotel is very decent. Also the banquet hall is also very good. Only concern i have seen in food. I just visited an engagement occasion.. the buffet is indian but there is improvement needed in taste because it is very bland.",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "a month ago",
    avatar: reviewIcon,
  },
  {
    name: "Shivam Shukla",
    reviewCount: 4,
    timeAgo: "7 months ago",
    text: "This hotel is an excellent venue for small family gatherings. Its exceptional cuisine is a significant highlight.",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "7 months ago",
    avatar: reviewIcon,
  },
  {
    name: "Mantu Kumar",
    reviewCount: 1,
    timeAgo: "a month ago",
    text: "I had a fantastic stay! The room was spotless, the staff were incredibly friendly! Thanks Atul shukla Ji",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "a month ago",
    avatar: reviewIcon,
  },
  {
    name: "Pranjal Srivastava",
    reviewCount: 4,
    timeAgo: "4 years ago",
    text: "I booked this hotel for my sister's engagement. The service was very much satisfactory and staff is very well trained. Everything went too smoothly. Thankyou for your cooperative services. …",
    ownerReply: "Thanks",
    ownerTimeAgo: "4 years ago",
    avatar: reviewIcon,
  },
  {
    name: "Shreya",
    reviewCount: 1,
    timeAgo: "4 months ago",
    text: "Excellent staff, top notch food- no complaints on quality or quantity, decently sized rooms with all standard amenities. Cleanliness is given priority. Overall a highly recommended one stop solution for hosting parties.",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "4 months ago",
    avatar: reviewIcon,
  },
  {
    name: "Aqdum Wasim",
    reviewCount: 1,
    timeAgo: "2 years ago",
    text: "Service was awesome and taste of starter was also great but traditional flavour of awadhi cuisine was missing in mutton biryani. Overall it was very nice",
    ownerReply: "Thanks 🙏",
    ownerTimeAgo: "2 years ago",
    hasPhoto: true,
    avatar: reviewIcon,
  },
];

const Review = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === Math.ceil(reviews.length / 3) - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="review-section">
      <div className="review-header">
       
        <h2>What They Say</h2>
      </div>

      <div className="review-slider">
        <div
          className="review-container"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {Array.from({ length: Math.ceil(reviews.length / 3) }).map((_, groupIndex) => (
            <div className="review-group" key={groupIndex}>
              {reviews.slice(groupIndex * 3, groupIndex * 3 + 3).map((review, idx) => (
                <div className="review-card" key={idx}>
                  <div className="review-avatar">
                    <img src={review.avatar} alt={review.name} /> {/* Changed to review.avatar */}
                  </div>
                  <div className="review-content">
                    <p className="review-text">"{review.text}"</p>
                    <p className="review-author">
                      {review.name} - ⭐⭐⭐⭐⭐
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="review-dots">
        {Array.from({ length: Math.ceil(reviews.length / 3) }).map((_, idx) => (
          <span
            key={idx}
            className={`dot ${currentIndex === idx ? 'active' : ''}`}
            onClick={() => handleDotClick(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default Review;